"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = require("../Button");

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var processArg = function processArg(arg) {
  var _arg$comp = arg.comp,
      comp = _arg$comp === void 0 ? null : _arg$comp,
      _arg$type = arg.type,
      type = _arg$type === void 0 ? "button" : _arg$type,
      rest = _objectWithoutProperties(arg, ["comp", "type"]);

  return _objectSpread({
    Comp: comp ? comp : type === "link" ? _Button.LinkButton : _Button.Button,
    type: type
  }, rest);
};

var Header = function Header(_ref) {
  var title = _ref.title,
      breadcrumbs = _ref.breadcrumbs,
      subtitle = _ref.subtitle,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: "".concat(theme.headerBg, " ").concat(theme.ySpace, " ").concat(theme.headerShadow, " px-4 sm:px-6 lg:px-8")
  }, breadcrumbs ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "sm:hidden"
  }), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "hidden sm:flex items-center text-sm leading-5 font-medium"
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.contentWidth, " md:flex md:items-center md:justify-between")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 min-w-0"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-2xl font-bold leading-7 ".concat(theme.text, " sm:text-3xl sm:leading-9 sm:truncate")
  }, title), subtitle ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap"
  }) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"
  }, actions.map(processArg).map(function (_ref2, i) {
    var Comp = _ref2.Comp,
        rest = _objectWithoutProperties(_ref2, ["Comp"]);

    return /*#__PURE__*/_react["default"].createElement(Comp, _extends({
      className: "ml-2",
      key: i
    }, rest));
  }))));
};

var _default = Header;
exports["default"] = _default;